enum PciDashboardScenarioTypeEnum {
  Original = "Original",
  Terminated = "Terminated",
  Targeted = "Targeted",
  TermTargeted = "TermTargeted",
}

export { PciDashboardScenarioTypeEnum };
